import { v4 as uuidv4 } from 'uuid';

/**
 * Helper class to manage session (Singleton)
 * */
class SessionHelper {
	static _sessionId;

  static resetSessionId() {
    SessionHelper._sessionId = uuidv4();
  }
  
	static getSessionId() {
    if (SessionHelper._sessionId == null) {
      SessionHelper._sessionId = uuidv4();
    }

    return SessionHelper._sessionId;
  }
}

export default SessionHelper;